var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"journal-table"},[_vm._l((_vm.logs),function(log,logIndex){return [(logIndex <= 20 * _vm.visible)?_c('table-item',{key:logIndex,staticClass:"mb-5 last:mb-0",attrs:{"item":log}}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }